import { Calendar, MessageCircle, Shield, Award, Users } from "lucide-react";
import { Button } from "./ui/button";

const HeroSection = () => {
  const scrollToBooking = () => {
    document.querySelector("#booking")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative min-h-screen pt-20 md:pt-24 overflow-hidden" data-testid="hero-section">
      {/* Background */}
      <div className="absolute inset-0 bg-stone-50">
        <div className="absolute right-0 top-0 w-1/2 h-full hidden lg:block">
          <img
            src="/images/skyhero.jpg"
            alt="Sky PhysioRehab - Diastasis Recti Treatment"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 hero-overlay"></div>
        </div>
        <div className="absolute left-0 bottom-0 w-96 h-96 glow-accent opacity-50"></div>
      </div>

      <div className="section-container relative z-10">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center min-h-[calc(100vh-6rem)]">
          {/* Content */}
          <div className="py-8 lg:py-16">
            {/* Trust Badge */}
            <div className="inline-flex items-center gap-2 bg-pink-100 text-blue-800 px-4 py-2 rounded-full text-sm font-medium mb-6" data-testid="trust-badge">
              <Shield size={16} className="text-emerald-600" />
              Safe & Non-Surgical Treatment
            </div>

            {/* Main Headline */}
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-blue-900 mb-6 tracking-tight" data-testid="hero-headline">
              Diastasis Recti Treatment in Lucknow
            </h1>

            {/* Subheadline */}
            <p className="text-lg md:text-xl text-stone-600 mb-6 max-w-xl" data-testid="hero-subheadline">
              Regain Your Core Strength After Pregnancy with Safe & Scientifically Guided Physiotherapy by{" "}
              <span className="text-blue-700 font-semibold">Expert Women Physiotherapist</span>
            </p>

            {/* Authority Stats */}
            <div className="flex flex-wrap gap-4 md:gap-6 mb-8">
              <div className="flex items-center gap-2 text-stone-700" data-testid="stat-experience">
                <Award className="text-blue-700" size={20} />
                <span className="font-semibold">17+ Years Experience</span>
              </div>
              <div className="flex items-center gap-2 text-stone-700" data-testid="stat-patients">
                <Users className="text-blue-700" size={20} />
                <span className="font-semibold">7000+ Women Treated</span>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              <Button
                onClick={scrollToBooking}
                className="btn-primary flex items-center justify-center gap-2 text-base"
                data-testid="hero-book-btn"
              >
                <Calendar size={20} />
                Book Consultation
              </Button>
              <a
                href="https://wa.me/918800095625?text=Hi%2C%20I%20want%20to%20book%20a%20consultation%20for%20Diastasis%20Recti%20Treatment"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-whatsapp flex items-center justify-center gap-2 text-base"
                data-testid="hero-whatsapp-btn"
              >
                <MessageCircle size={20} />
                WhatsApp Now
              </a>
            </div>

            {/* Limited Slots Notice */}
            <div className="flex items-center gap-2 text-sm text-stone-500" data-testid="urgency-notice">
              <span className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse"></span>
              Limited consultation slots available this week
            </div>
          </div>

          {/* Mobile Image */}
          <div className="lg:hidden rounded-2xl overflow-hidden shadow-xl">
            <img
              src="/images/skyhero.jpg"
              alt="Sky PhysioRehab - Diastasis Recti Treatment"
              className="w-full h-64 object-cover object-top"
              data-testid="hero-mobile-image"
            />
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 hidden lg:block">
        <div className="scroll-indicator text-blue-400">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 5v14M5 12l7 7 7-7" />
          </svg>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
